import client from './client';

export const algorithmApi = {
  getAlgorithms: async () => {
    const response = await client.get('/api/algorithm');
    return response.data;
  },

  getAlgorithm: async (id) => {
    const response = await client.get(`/api/algorithm/${id}`);
    return response.data;
  },

  createAlgorithm: async (algorithmData) => {
    const response = await client.post('/api/algorithm', algorithmData);
    return response.data;
  },

  updateAlgorithm: async (id, algorithmData) => {
    const response = await client.put(`/api/algorithm/${id}`, algorithmData);
    return response.data;
  },

  deleteAlgorithm: async (id) => {
    const response = await client.delete(`/api/algorithm/${id}`);
    return response.data;
  },

  getTemplates: async () => {
    const response = await client.get('/api/algorithm/templates');
    return response.data;
  },

  getTemplate: async (id) => {
    const response = await client.get(`/api/algorithm/templates/${id}`);
    return response.data;
  },

  getRunning: async () => {
    const response = await client.get('/api/algorithm/running');
    return response.data;
  },

  runAlgorithm: async (params) => {
    const response = await client.post('/api/algorithm/run', params);
    return response.data;
  },

  getLogs: async (id, params = {}) => {
    const response = await client.get(`/api/algorithm/logs/${id}`, { params });
    return response.data;
  },

  stopAlgorithm: async (id) => {
    const response = await client.post(`/api/algorithm/stop/${id}`);
    return response.data;
  },

  killAll: async (params = {}) => {
    const response = await client.post('/api/algorithm/kill-all', params);
    return response.data;
  },

  startTwap: async (params) => {
    const response = await client.post('/api/algorithm/twap', params);
    return response.data;
  },

  stopTwap: async (id) => {
    const response = await client.post(`/api/algorithm/twap/${id}/stop`);
    return response.data;
  },

  listTwapJobs: async () => {
    const response = await client.get('/api/algorithm/twap');
    return response.data;
  },

  getTwapJob: async (id) => {
    const response = await client.get(`/api/algorithm/twap/${id}`);
    return response.data;
  },

  backtest: async (params) => {
    const response = await client.post('/api/algorithm/backtest', params, {
      timeout: 120000,
    });
    return response.data;
  },
};
